import React from 'react';
import PropTypes from 'prop-types';
import { getIconPath } from '@tcp/core/src/utils';
import {
  globalCommonBrowseLabels,
  GLOBAL_COMMON_BROWSE_LABELS,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import Image from '@tcp/core/src/components/common/atoms/Image';
import ModuleX from '@tcp/core/src/components/common/molecules/ModuleX/ModuleX.jsx';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';
import Anchor from '../../../../../atoms/Anchor';
import { parseData, getCategoryIdentifier } from './sizeChartUtils';

class NewSizeChart extends React.Component {
  constructor(props) {
    super(props);

    this.globalCommonBrowse = getLabelFromCopyOrFromTranslation(
      GLOBAL_COMMON_BROWSE_LABELS,
      globalCommonBrowseLabels
    );
  }

  componentDidMount() {
    const { sizeChartModuleXContentId, fetchSizeGuideModuleX, primaryBrand } = this.props;
    if (sizeChartModuleXContentId) {
      fetchSizeGuideModuleX({
        contentId: sizeChartModuleXContentId?.contentId,
        brand: primaryBrand.toLowerCase(),
      });
      const { categoryPath2Map } = this.props;
      const { l1Category, l2Category } = getCategoryIdentifier(categoryPath2Map);
      if (window && l1Category && l2Category && window?.setSizechartCategory) {
        window.setSizechartCategory(l1Category, l2Category);
      }
    }
  }

  isNewSizeGuide = (e) => {
    const { setPdpTabSectionName } = this.props;
    e.preventDefault();
    setTimeout(() => {
      setPdpTabSectionName('sizeChart');
      const scrollId = 'pdp-tab-wrapper';
      const tabSection = document?.getElementById(scrollId);
      const pdpTabScroll = document?.querySelector('.pdp-redesign-tab-structure');
      const xPos = pdpTabScroll && pdpTabScroll.getBoundingClientRect().left;
      if (tabSection) {
        pdpTabScroll.scrollTo({
          left: xPos + 150,
          behavior: 'smooth',
        });
        tabSection.scrollIntoView();
      }
    }, 0);
  };

  render() {
    const {
      sizeChartDetails,
      isNewPJPPDPRedesignEnabled,
      hideSizeGuideButton,
      isPDP,
      primaryBrand,
      sizeChartImageURL,
    } = this.props;

    const dataObj = parseData(sizeChartDetails);
    const sizeChartRuler = getIconPath('size-chart-ruler');
    const content1 = this.props[`sizeChartModuleXContent${primaryBrand}`] ? (
      <ModuleX
        richTextList={[{ text: this.props[`sizeChartModuleXContent${primaryBrand}`].richText }]}
      />
    ) : (
      <LoaderSkelton height="100px" />
    );

    return (
      <>
        {!hideSizeGuideButton && (
          <div className="size-chart-btn-pdp">
            <Anchor noLink {...dataObj} onClick={this.isNewSizeGuide}>
              <div className="size-chart-pdp-redesign">
                <Image
                  className="size-chart-ruler"
                  src={sizeChartRuler}
                  alt="size-chart-ruler"
                  width="20px"
                  height="18px"
                />
                <div className="size-chart-label">
                  {renderLabel(this.globalCommonBrowse?.lbl_size_guide, 'lbl_size_guide')}
                </div>
              </div>
            </Anchor>
          </div>
        )}
        {isNewPJPPDPRedesignEnabled && !isPDP && (
          <div id={'tab-structure-sizechart'} aria-labelledby={'tab-sizechart'} role="tabpanel">
            {sizeChartImageURL ? <Image id="altSizeChart" src={sizeChartImageURL} /> : content1}
          </div>
        )}
      </>
    );
  }
}

NewSizeChart.propTypes = {
  sizeChartDetails: PropTypes.string,
  labels: PropTypes.shape({ sizeChart: PropTypes.string }),
  categoryPath2Map: PropTypes.shape([]),
  selectedFit: PropTypes.string,
  primaryBrand: PropTypes.string,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  hideSizeGuideButton: PropTypes.bool,
  setPdpTabSectionName: PropTypes.func,
  isPDP: PropTypes.bool,
};

NewSizeChart.defaultProps = {
  sizeChartDetails: '',
  labels: {
    sizeChart: 'Size Chart',
  },
  categoryPath2Map: [],
  selectedFit: '',
  primaryBrand: '',
  isNewPJPPDPRedesignEnabled: false,
  hideSizeGuideButton: false,
  setPdpTabSectionName: () => {},
  isPDP: false,
};

export default NewSizeChart;
